import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';

type Props = {
  children: React.ReactNode;
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const CustomModal = ({ children, isVisible, setVisible }: Props) => {
  const [bShowModal, set_bShowModal] = useState(false);

  const onCloseModal = () => {
    set_bShowModal(false);
    setVisible(false);
  };

  useEffect(() => {}, []);

  useEffect(() => {
    set_bShowModal(isVisible);
  }, [isVisible]);

  return (
    <>
      <Style>
        <Modal
          isOpen={bShowModal}
          onRequestClose={onCloseModal}
          className="detailModal modal-content bottom"
          closeTimeoutMS={100}
          ariaHideApp={false}>
          <div className="modalContainer">{children}</div>
        </Modal>
      </Style>
    </>
  );
};

export default CustomModal;

const Style = styled.div``;
